import { FC, ReactElement } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './SimpleDialog.scss';

type SimpleDialogProps = {
	open: boolean;
	title?: string;
	content?: ReactElement;
	onClose: () => void;
};

const SimpleDialog: FC<SimpleDialogProps> = ({
	onClose,
	open,
	title,
	content,
}) => (
	<Dialog onClose={onClose} open={open} className="SimpleDialog">
		<div className="close">
			<CloseIcon onClick={onClose} />
		</div>
		{title && <DialogTitle>{title}</DialogTitle>}
		{!!content && <DialogContent>{content}</DialogContent>}
	</Dialog>
);

export default SimpleDialog;
